import { lazy } from "react";

export const RewardsPage = lazy(() => import("./rewardsPage"));
